import { render, staticRenderFns } from "./PostsGrid.vue?vue&type=template&id=531ad41e&"
import script from "./PostsGrid.vue?vue&type=script&lang=js&"
export * from "./PostsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PostsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports